export const seoRulesTargetTypeMapper = {
  SeoPageEntity: 'page',
  SportEntity: 'sport',
  RegionEntity: 'region',
  LeagueEntity: 'league',
  CasinoCategoryEntity: 'casino-category'
}
